'use strict';

require('bootstrap');


// WEBPACK FOOTER //
// ./scripts/autoload/_bootstrap.js